import { getAuthorization } from "../api/Authorization";

export const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const CHAT_AI_URL = process.env.REACT_APP_URL;
export const AI_DOMAIN_NAME = process.env.REACT_APP_AI_DOMAIN_NAME;
export const APP_ENV = process.env.REACT_APP_ENV;
export const OECCBB_API_BASE_URL = process.env.REACT_APP_OECCBB_API_BASE_URL;
export const OFFCOURSE_API_BASE_URL =
  process.env.REACT_APP_OFFCOURSE_API_BASE_URL;
export const PAGE_OFFSET = 4;
export const APP = {
  apiUrl: API_BASE_URL,
  authAppName: "CHATAI",
  autoLoginUrl: `${AI_BASE_URL}/webview/autologin`,
  clientCredential: {
    grant_type: "client_credentials",
    client_id: "10012",
    client_secret: "EmailingSecretS#K$",
    scope: "ttp",
  },
};
export const getSilos = async (user, token) => {
  try {
    const silos = await getAuthorization(user, token);
    return silos.filter((silo) => {
      if (
        typeof silo === "object" &&
        silo.base_key !== null &&
        silo.base_key !== ""
      ) {
        return true;
      }
      return false;
    });
  } catch (error) {
    console.error("Failed to fetch silos:", error);
    return [];
  }
};
export const SILOS_ID = {
  "Manuel IPP 2025": 6,
};
